export default __webpack_public_path__ + "static/mobileBackground-5cac761aa531292824657518abdc9a86.png";